import { Input, Instruction, Library } from "../machinelogic/types";

export const PushButtonInputLevelLabels = ['Released', 'Pushed'];

export const PushButtonInputEdgeLabels = {
  rising: 'Released to Pushed',
  falling: 'Pushed to Released',
};

export const isInputPushButton = function (input?: Input) {
  return input && input.deviceType === 'pushButtonModule';
};
